<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <apexchart type="line" height="310" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  name: "DailyPercentage",
  data: () => ({
    series: [
      {
        name: "Daily % Change",
        type: "column",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: [
        "#008FFB",
        "#008FFB",
        "#008FFB",
        "#F86624",
        "#4CAF50",
        "#d6c51b"
      ],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      tooltip: {
        x: {
          show: true,
          format: "dd MMM"
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          dataLabels: {
            position: "top"
          }
        }
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [0],
        style: {
          //fontSize: "12px",
          colors: ["#fff"]
        },
        background: {
          enabled: false
        }
      },
      markers: {
        size: 0
      },
      stroke: {
        width: [0, 3]
      },
      xaxis: {
        type: "datetime",
        //categories: [],
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      },
      yaxis: [
        {
          title: {
            text: "Percentage"
          }
        }
      ]
    }
  }),
  methods: {
    loadCases(data, countryDisplay) {
      this.series[0].data = [];
      
      //first loop through each country and concat the cases data to find the distinct dates
      var allcases = []
      for (var i = 0; i < data.length; i++) {
        allcases = allcases.concat(data[i].cases)
      }

      //sort by date
      allcases = allcases.sort(function(a, b) {
        a = a.date;
        b = b.date;
        return a < b ? -1 : a > b ? 1 : 0;
      });

      //then get all the distinct dates
      var dates = [];
      dates = Array.from(new Set(allcases.map(cas => cas.date))).map(date => {
        return date;
      });

      //loop through dates and get daily confirmed
      var vals = [];

      //loop through all the dates and find cases
      for (var i = 0; i < dates.length; i++) {
        var thisDate = dates[i];

        //filter the matching dates from all cases
        var cdat = allcases.filter(c => c.date === thisDate)

        //CONFIRMED
        var confirmed = cdat.reduce(function(prev, cur) {
          return prev + cur.cumulative_cases;
        }, 0);
        
        //find previous cumulative count
        var prevInd = i - 1
        var prevprevInd = i - 2

        if(prevprevInd >= 0) {
          var prevDate = dates[prevInd]
          var prevprevDate = dates[prevprevInd]

          //filter the matching dates from all cases
          var prevcdat = allcases.filter(c => c.date === prevDate)
          var prevprevcdat = allcases.filter(c => c.date === prevprevDate)

          //CONFIRMED
          var prevconfirmed = prevcdat.reduce(function(prev, cur) {
            return prev + cur.cumulative_cases;
          }, 0);

          var prevprevconfirmed = prevprevcdat.reduce(function(prev, cur) {
            return prev + cur.cumulative_cases;
          }, 0);

          var diff = confirmed - prevconfirmed
          var prevdiff = prevconfirmed - prevprevconfirmed

          var delta = diff - prevdiff

          //calc the pec
          var perc = 0
          if(prevdiff > 0) {
            perc = (delta/prevdiff)*100
            perc = parseFloat(perc.toFixed(2))
          }

          //push to array
          vals.push([
            this.$moment(thisDate, "YYYY-MM-DD")
              .add(10, "hours")
              .toDate(),
            perc
          ]);
          
        }
        // else {
        //   //push to arrays
        //   vals.push([
        //     this.$moment(thisDate, "YYYY-MM-DD")
        //       .add(10, "hours")
        //       .toDate(),
        //     confirmed
        //   ]);

        // }         
      }

      //set the graph data
      this.series = [{
        name: "Daily % Change",
        type: "column",
        data: vals
      }]

    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
